import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import axios from "../../containers/api";
import { showCatchError } from "../../helpers/Utils";

class ReturnBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message:
        this.props.location.search !== undefined &&
        this.props.location.search !== null
          ? new URLSearchParams(this.props.location.search).get("msg")
          : null,
      result: [],
      Status: 0,
      Token: null,
      StatusMsg: null,
      orderId: null,
      isPay: true,
    };
  }

  async componentDidMount() {
    const splitText = this.state.message?.split("?") || [];
    if (splitText.length > 3) {
      this.setState({
        Status: splitText[1],
        Token: splitText[2],
        StatusMsg: splitText[0],
        orderId: splitText[3],
      });
    } else {
      this.setState({ StatusMsg: this.state.message });
    }
  }

  Redirectback = () => {
    this.props.showSpinner();
    axios
      .post("/api/v1/sale-payments/VerifySalePayment")
      .then((res) => {
        if (res.status === 200) {
          this.props.hideSpinner();
          this.setState({
            result: res.data,
          });
        }
      })
      .catch((error) => {
        this.setState({ isPay: false });
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  render() {
    const { StatusMsg, Token, orderId, Status } = this.state;
    const isSuccess =
      Status === "0" || (StatusMsg && StatusMsg.includes("موفق")); // تشخیص پرداخت موفق

    return (
      <Row
        className="justify-content-center align-items-center text-center"
        style={{ minHeight: "100vh", backgroundColor: "#f9f9f9" }}
      >
        <Col xs="11" sm="8" md="5" lg="4">
          <Card className="shadow-sm border-0" style={{ borderRadius: "20px" }}>
            <CardBody>
              {/* لوگو */}
              <div className="logo-single mb-2" />

              {/* وضعیت پرداخت */}
              <div className="d-flex flex-column align-items-center mt-4 mb-3">
                {isSuccess ? (
                  <FaCheckCircle color="#28a745" size={60} />
                ) : (
                  <FaTimesCircle color="#dc3545" size={60} />
                )}
                <h5
                  className="mt-3"
                  style={{ color: isSuccess ? "#28a745" : "#dc3545" }}
                >
                  {StatusMsg || "وضعیت پرداخت مشخص نیست"}
                </h5>
              </div>

              {/* اطلاعات تراکنش */}
              {Token && (
                <p className="text-muted mb-1" style={{ fontSize: "14px" }}>
                  Token: {Token}
                </p>
              )}
              {orderId && (
                <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
                  کد رهگیری : {orderId}
                </p>
              )}

              {/* دکمه‌ها */}
              <div className="d-flex flex-column gap-2 mt-3 mb-2">
                <a href={"bank://bar/success"}>
                  <Button
                    color="warning"
                    className="w-100"
                    style={{ borderRadius: "30px", fontWeight: "600" }}
                  >
                    بازگشت به اپلیکیشن
                  </Button>
                </a>
                <br></br>
                <a href={"/"}>
                  <Button
                    outline
                    color="secondary"
                    className="w-100"
                    style={{ borderRadius: "30px", fontWeight: "600" }}
                  >
                    بازگشت به نیمروز بار
                  </Button>
                </a>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default ReturnBank;
